// extracted by mini-css-extract-plugin
export default {"card":"Projects_card__uPsP6","showcase":"Projects_showcase__ssRVe","projectCard":"Projects_projectCard__ghmCD","projects":"Projects_projects__Q0VAA"};